// Allow Gravity Forms Quiz instant feedback answers to be changed
// The plugin's gquizShowAnswer() disables the other choices and its handlers ignore a field once it is answered
( function() {

  // If the Quiz add-on's instant feedback script isn't loaded
  if ( typeof gquizShowAnswer != 'function' || typeof jQuery == 'undefined' ) {
    return;
  }

  const gquizShowAnswerOriginal = gquizShowAnswer;

  // Remove any feedback and re-enable the choices in a quiz field
  const biroQuizReset = field => {

    field.find( '.gquiz-indicator, .gquiz-answer-explanation' ).remove();
    field.find( '.gquiz-correct-choice, .gquiz-incorrect-choice' ).removeClass( 'gquiz-correct-choice gquiz-incorrect-choice' );
    field.find( 'input[type="radio"]' ).prop( 'disabled', false );

  };

  // Replace the plugin's function so that every call clears the previous answer first
  window.gquizShowAnswer = function( radioInput ) {

    const field = jQuery( radioInput ).closest( '.gquiz-field' );
    const focused = document.activeElement;

    biroQuizReset( field );
    gquizShowAnswerOriginal( radioInput );
    field.find( 'input[type="radio"]' ).prop( 'disabled', false );

    // The plugin briefly disables the focused choice, which drops focus and stops arrow keys working
    if ( field[0].contains( focused ) && document.activeElement !== focused ) {
      focused.focus();
    }

    // Only reveal the correct answer and the explanation once the correct answer is chosen
    if ( field.find( 'label[for="' + radioInput.id + '"]' ).hasClass( 'gquiz-incorrect-choice' ) ) {
      field.find( '.gquiz-answer-explanation' ).remove();
      field.find( '.gquiz-correct-choice' ).removeClass( 'gquiz-correct-choice' );
    }

  };

  // Redo the feedback for fields answered before this script loaded
  jQuery( '.gquiz-field.gquiz-instant-feedback-validated input[type="radio"]:checked' ).each( function() {
    window.gquizShowAnswer( this );
  } );

  // Show feedback for every change of answer after the first
  jQuery( document ).on( 'change', '.gquiz-field.gquiz-instant-feedback input[type="radio"]', function() {

    if ( this.checked && jQuery( this ).closest( '.gquiz-field' ).hasClass( 'gquiz-instant-feedback-validated' ) ) {
      window.gquizShowAnswer( this );
    }

  } );

} )();
